import { useCallback, useContext } from 'react';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { EditorConfigContext } from '../contexts/EditorConfigContext';
import { getGlobalVars } from '../utils/globalVarUtil';
import { insertContent, insertLink } from '../utils/documentUtils';
import { convertToPlaintextState } from '../utils/plaintextUtils';
export default function useContentInserter({
  insertionType,
  onInsertComplete,
  onInsertContent,
  transformTransaction
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const editorConfig = useContext(EditorConfigContext);
  const {
    usePlaintextMode,
    plaintextOptions
  } = getGlobalVars(editorConfig);
  return useCallback(({
    htmlBody,
    metadata
  }) => {
    let newState;
    if (insertionType === 'link') {
      let tr = insertLink({
        htmlBody,
        editorState,
        from: editorState.selection.from,
        to: editorState.selection.to
      });
      if (transformTransaction) {
        tr = transformTransaction(tr);
      }
      newState = editorState.apply(tr);
    } else {
      newState = insertContent({
        htmlBody,
        editorState,
        from: editorState.selection.from,
        to: editorState.selection.to
      });
    }
    setEditorState(usePlaintextMode ? convertToPlaintextState(newState, plaintextOptions) : newState);
    onInsertComplete === null || onInsertComplete === void 0 || onInsertComplete();
    if (metadata !== undefined) {
      onInsertContent === null || onInsertContent === void 0 || onInsertContent(metadata);
    }
  }, [editorState, setEditorState, insertionType, usePlaintextMode, plaintextOptions, onInsertComplete, onInsertContent, transformTransaction]);
}